import store from "../../../store";
import sqftConfig from "../components/canvas/store/sqftConfig";
import {setSlabImageHeight, setSlabImageWidth} from "../../../actions/sqftSlabFunctions";
import Radius from "../components/canvas/core/controls/radius";

export const onMeasureUnitChange = () => {
  Radius.onMeasureUnitChange();

  switch(sqftConfig.measureUnit) {
    case "Metric":
      store.dispatch(setSlabImageWidth(sqftConfig.slab.imageWidthMetric));
      store.dispatch(setSlabImageHeight(sqftConfig.slab.imageHeightMetric));
      break;
    case "Imperial":
    default:
      store.dispatch(setSlabImageWidth(sqftConfig.slab.imageWidthImperial));
      store.dispatch(setSlabImageHeight(sqftConfig.slab.imageHeightImperial));
  }
}
